import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


import { APP_ROOT_URL } from '../../actions/urlTypes';

import { clearAllSearch } from '../../actions/adminActions';

import UserIcon from '../../components/admin/shared/UserIcon';
import AccountsIcon from '../../components/admin/shared/AccountsIcon';
import UserSearch from '../../components/admin/user/UserSearch';

class Admin extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  state = {
    isUsers: true,
    isUserManagement: true,
  }

  UNSAFE_componentWillMount() {
    const { universityUser, internalAdmin, impersonated } = this.props.loginResponse.data;
    if (internalAdmin && !universityUser && !impersonated) {
      if (this.props.route.path === '/admin') {
        this.context.router.push(`${APP_ROOT_URL}/admin/users`);
      }
    } else {
      this.context.router.push('/essentials/crosstab');
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const isUsers = nextProps.location.pathname === '/admin/users';
    this.setState({ isUsers });

    if (!isUsers && !this.state.isUserManagement) {
      this.setState({ isUserManagement: true });
    }
  }

  componentWillUnmount() {
    this.props.clearAllSearch();
  }

  showUserManagement = () => {
    this.setState({ isUserManagement: !this.state.isUserManagement });
  }

  render() {
    const { children } = this.props;
    const { isUsers, isUserManagement } = this.state;
    return (
      <div className="admin">
        <div className="admin-container">
          <div className="admin-navigation">
            <div className="admin-header-label">Administration</div>
            <ul className="admin-nav">
              <li>
                <Link to={`${APP_ROOT_URL}/admin/users`} activeClassName="active" className="admin-nav--link">
                  <UserIcon /> <span>User Management</span>

                  {isUsers && <button
                    type="button"
                    onClick={this.showUserManagement}
                    className="dd-menu--btn"
                  >
                    <i className={isUserManagement ? 'dd-up-arrow-icon' : 'dd-down-arrow-icon'} />
                  </button>}
                </Link>
                {isUsers && isUserManagement && <UserSearch />}
              </li>
              <li>
                <Link to={`${APP_ROOT_URL}/admin/accounts`} activeClassName="active" className="admin-nav--link">
                  <AccountsIcon /> <span>Account Management</span>
                </Link>
              </li>
            </ul>
          </div>
          <div className="admin-main-body">
            {children}
          </div>
        </div>
      </div>
    );
  }
}

Admin.propTypes = {
  children: PropTypes.node,
  clearAllSearch: PropTypes.func,
  route: PropTypes.shape({
    path: PropTypes.string,
  }),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      universityUser: PropTypes.boolean,
      internalAdmin: PropTypes.boolean,
      impersonated: PropTypes.boolean,
    }),
  }),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
  };
}

const mapDispatchToProps = dispatch => {
  return {
    clearAllSearch: bindActionCreators(clearAllSearch, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Admin);
